import { For, Show } from "solid-js";
import { EXPLORE_PLAN } from "~/components/billing/planFeatures";
import { DownloadButton, GetStartedButton } from "~/components/marketing/CTAButtons";
import { COMPLIANCE_BADGES } from "~/components/marketing/MarketingFooter";
import { useI18n } from "~/i18n";
import { hasChiefBuild } from "~/lib/chiefDownload";
import { useOS } from "~/lib/useOS";

export const signupCredits = () => ({
  credits: EXPLORE_PLAN.signupCredits.toLocaleString("en-US"),
  daily: EXPLORE_PLAN.dailyCredits.toLocaleString("en-US"),
});

/** A page's last word: Download + Get started, the free-start line, and the compliance badges. `from` tags the download click. */
export const ClosingCTA = (props: { id: string; title: string; from: string }) => {
  const { t } = useI18n();
  const os = useOS();
  return (
    <section
      aria-labelledby={props.id}
      class="relative overflow-hidden border-t border-primary-border bg-panel px-4 py-24 sm:px-6 sm:py-32 lg:px-8"
    >
      <div
        aria-hidden="true"
        class="pointer-events-none absolute -bottom-72 left-1/2 h-112 w-240 -translate-x-1/2 rounded-full bg-brand/10 blur-3xl"
      />
      <div class="relative mx-auto flex max-w-3xl flex-col items-center text-center">
        <img src="/images/chief-logo-gold-crown-only.svg" alt="" class="h-8 w-auto" />
        <h2 id={props.id} class="mt-6 text-4xl font-semibold tracking-tight text-balance sm:text-6xl">
          {props.title}
        </h2>
        <div class="mt-10 flex flex-wrap items-center justify-center gap-3">
          <DownloadButton from={props.from} size="lg" />
          <Show when={hasChiefBuild(os())}>
            <GetStartedButton variant="secondary" size="lg" />
          </Show>
        </div>
        <p class="mt-5 font-mono text-xs text-secondary-text">
          {t("marketing.home.closing.microline", signupCredits())}
        </p>
        <a
          href="https://trust.chief.bot"
          target="_blank"
          rel="noopener noreferrer"
          class="mt-12 flex items-center gap-4 rounded-lg focus-visible:ring-2 focus-visible:ring-brand focus-visible:outline-none"
        >
          <For each={COMPLIANCE_BADGES}>
            {(badge) => <img src={badge.src} alt={t(badge.label)} loading="lazy" class="h-16 w-auto" />}
          </For>
        </a>
      </div>
    </section>
  );
};
